import { useMemo, FC, PropsWithChildren } from 'react'
import SlideInMotion, { SlideInDirection } from './SlideInMotion'
import * as layout from '../styles/Layout.styled'
import * as about from '../styles/About.styled'
import { Section } from '../typing/enums'

const LinkAndLogo: FC<
  PropsWithChildren<{
    myHref:string,
  }>
> = ({
  myHref,
  children,
}) => {
  return (
    <about.StyledLink
      href={myHref}
      target='_blank'
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1,
        ease: 'easeInOut',
        delay: 1,
      }}
    >
      <about.StyledLogoWrapper
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        {children}
      </about.StyledLogoWrapper>
    </about.StyledLink>
  )
}

export const About: FC = () => {
  const aboutText = useMemo<string>(() => {
    return (
      'Welcome to Pour and Fire Pottery! This is a place to share my work, showcasing ' +
      'the forms, textures, and finishes that I find most interesting. I enjoy slip ' +
      'casting for its balance of precision and creativity. Working with molds allows ' +
      'for consistency, but each piece still carries its own character. The process is ' +
      'both structured and hands-on, which makes it deeply satisfying. Enjoy!'
    )
  }, [])

  return (
    <>
      <SlideInMotion direction={SlideInDirection.left} delay={0.4}>
        <layout.StyledSectionName>{Section.about}</layout.StyledSectionName>
      </SlideInMotion>
      <SlideInMotion direction={SlideInDirection.left} delay={0.6}>
        <about.StyledContainer>
          <layout.StyledSectionText>&nbsp;&nbsp;{aboutText}</layout.StyledSectionText>
          <about.StyledLogoContainer>
            <LinkAndLogo
              myHref='https://www.instagram.com/pourandfirepottery/'
            >
              <about.StyledLogoInstagram size={58} />
            </LinkAndLogo>
            <LinkAndLogo
              myHref='mailto:pourandfirepottery@gmail.com'
            >
              <about.StyledLogoMail size={84} />
            </LinkAndLogo>
          </about.StyledLogoContainer>
        </about.StyledContainer>
      </SlideInMotion>
    </>
  )
}
